import CustomerList from './List';
import { CustomerCreate, CustomerEdit } from './Form';

export default {
  list: CustomerList,
  create: CustomerCreate,
  edit: CustomerEdit,
};
